import { render, staticRenderFns } from "./assignee.vue?vue&type=template&id=8cf87190"
import script from "./assignee.vue?vue&type=script&lang=js"
export * from "./assignee.vue?vue&type=script&lang=js"
import style0 from "./assignee.vue?vue&type=style&index=0&id=8cf87190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports